import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const IconComponent = React.forwardRef((props, ref) => <FontAwesomeIcon {...props} forwardedRef={ref} />);

const IconWithMargin = styled(IconComponent)({
    marginRight: 10
});

const MenuItemIcon = ({ icon }) => (
    <>
        {icon && (
            <i className="anticon">
                <IconWithMargin icon={icon} />
            </i>
        )}
    </>
);
export default MenuItemIcon;
